import { CouponsSchema } from './types';

export const initialState: CouponsSchema = {
  status: 'idle',
  data: {},
};
